module.exports = __webpack_public_path__ + "static/p14_cerditos-d772af5c07c1e97719eb54cc0543b8af.png";